import { VIDEO_HISTORY_NETWORK_ERROR } from 'Modules/videoHistory/constants/networkError.constants';
import type { IFetchSummaryResult, ISummary } from 'Modules/videoHistory/types/summary.types';
import type {
  IFetchTranscriptionsResult,
  ITranscription,
} from 'Modules/videoHistory/types/transcriptions.types';

/**
 * Type guards for narrowing summary and transcription fetch results.
 *
 * Fetch results are a union of the loaded model, `null` (404 or empty),
 * or `VIDEO_HISTORY_NETWORK_ERROR` when the request fails without an HTTP response.
 * These guards let callers distinguish between those cases without inspecting
 * the sentinel value directly.
 */

export const isNetworkFetchResult = (
  result: unknown
): result is typeof VIDEO_HISTORY_NETWORK_ERROR =>
  result === VIDEO_HISTORY_NETWORK_ERROR;

export const isSummary = (
  result: IFetchSummaryResult | undefined
): result is ISummary =>
  result !== undefined &&
  result !== null &&
  !isNetworkFetchResult(result);

export const isTranscription = (
  result: IFetchTranscriptionsResult | undefined
): result is ITranscription =>
  result !== undefined &&
  result !== null &&
  !isNetworkFetchResult(result);
